import { createInfiniteQuery, createQuery } from 'react-query-kit';

import { fetchData } from 'services/http/http';
import { buildFilterUrl } from 'support/helpers/urls/urls';
import portalSchema from 'support/types/schema-portal';

import { PAYMENT_RECONCILIATION_DETAIL_QUERY_KEY, PAYMENT_RECONCILIATION_QUERY_KEY } from '../queryKeys';

type GetPaymentReconciliationStatsResponse =
  portalSchema.paths['/v1/payment-reconciliation/stats']['get']['responses']['200']['content']['application/json'];

export const usePaymentReconciliationStats = createQuery<GetPaymentReconciliationStatsResponse, any, Error>({
  primaryKey: `${PAYMENT_RECONCILIATION_QUERY_KEY}/stats`,
  queryFn: async () => {
    const { data } = await fetchData<GetPaymentReconciliationStatsResponse>('/v1/payment-reconciliation/stats');
    return data;
  },
});

export type GetPaymentReconciliationsResponse =
  portalSchema.paths['/v1/payment-reconciliation']['get']['responses']['200']['content']['application/json'];

export const usePaymentReconciliations = createInfiniteQuery<GetPaymentReconciliationsResponse, any, Error>({
  primaryKey: PAYMENT_RECONCILIATION_QUERY_KEY,
  queryFn: async ({ queryKey: [, variables], pageParam, signal }) => {
    const urlParams = buildFilterUrl(
      { filterValues: [], ...variables.query, cursor: pageParam },
      { forApiRequest: true },
    );
    const { data } = await fetchData<GetPaymentReconciliationsResponse>('/v1/payment-reconciliation' + urlParams, {
      config: { signal },
    });
    return data;
  },
  getNextPageParam: (lastPage) => {
    return lastPage.meta.next_cursor;
  },
  getPreviousPageParam: (_, allPages) => allPages.at(-1)?.meta.prev_cursor,
});

export type GetPaymentReconciliationDetailResponse =
  portalSchema.paths['/v1/payment-reconciliation/{id}']['get']['responses']['200']['content']['application/json'];

export const usePaymentReconciliationDetail = createQuery<
  GetPaymentReconciliationDetailResponse,
  { id: string },
  Error
>({
  primaryKey: PAYMENT_RECONCILIATION_DETAIL_QUERY_KEY,
  queryFn: async ({ queryKey: [, params] }) => {
    const { data } = await fetchData<GetPaymentReconciliationDetailResponse>(`/v1/payment-reconciliation/${params.id}`);
    return data;
  },
});
